function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  if (typeof path === "function") return path(obj);

  const parts = String(path).split(".");
  let cur = obj;
  for (const part of parts) {
    if (cur == null) return undefined;
    cur = cur[part];
  }
  return cur;
}

function normalizeString(value) {
  if (value === null || value === undefined) return "";
  return String(value).toLowerCase();
}

function normalizeNumber(value) {
  if (value === null || value === undefined || value === "") {
    return Number.NEGATIVE_INFINITY;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : Number.NEGATIVE_INFINITY;
}

function normalizeDate(value) {
  const t = Date.parse(value);
  return Number.isFinite(t) ? t : Number.NEGATIVE_INFINITY;
}

function compare(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

export function sortItems(items, config) {
  const list = Array.isArray(items) ? items : [];
  const key = config?.key;
  if (!key) return list;

  const direction = (config?.direction || "asc").toLowerCase();
  const type = (config?.type || "string").toLowerCase();

  const dir = direction === "desc" ? -1 : 1;

  const decorated = list.map((item, index) => ({ item, index }));

  decorated.sort((x, y) => {
    const xvRaw = getByPath(x.item, key);
    const yvRaw = getByPath(y.item, key);

    let xv;
    let yv;

    if (type === "number") {
      xv = normalizeNumber(xvRaw);
      yv = normalizeNumber(yvRaw);
    } else if (type === "date") {
      xv = normalizeDate(xvRaw);
      yv = normalizeDate(yvRaw);
    } else {
      xv = normalizeString(xvRaw);
      yv = normalizeString(yvRaw);
    }

    const c = compare(xv, yv);
    if (c !== 0) return c * dir;

    // Stable sort fallback
    return x.index - y.index;
  });

  return decorated.map((x) => x.item);
}
